import { createGlobalState } from 'react-hooks-global-state';

const initialState = {
  isLoggedOut: false
};

export const { useGlobalState } = createGlobalState(initialState);